<script setup lang="ts">
// Shared blueprint "stage" used by every workflow scene so they stay uniform.
const grid = {
    backgroundImage:
        'linear-gradient(to right, rgba(56,189,248,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(56,189,248,0.06) 1px, transparent 1px)',
    backgroundSize: '26px 26px',
};
</script>

<template>
    <div
        class="relative aspect-[100/58] min-h-[210px] w-full overflow-hidden rounded-3xl border border-cyan-400/20 bg-slate-950 shadow-2xl"
    >
        <div
            class="pointer-events-none absolute inset-0 opacity-60"
            :style="grid"
        ></div>
        <div class="relative h-full w-full">
            <slot />
        </div>
    </div>
</template>
